import React, { ReactNode, useState } from "react"
import { CgClose } from "react-icons/cg"
import styled from "styled-components"
import UpdateShareHolding from "./updateShareHolding"
import ConfirmUpdateShare from "./confirmUpdateShareHolding"

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: #20200020;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalBox = styled.div`
  position: relative;
  padding: 50px;
  max-width: 30%;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #d4d4d4;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
`

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  appearance: none;
  background-color: transparent;
  border: 0;
  padding: 15px;
`

export enum UpdateShare {
  Form,
  Confirm,
  Error,
}

const ModalCard = ({
  onClose,
  children,
}: {
  onClose: () => void
  children: ReactNode
}) => {
  return (
    <ModalBox
      data-testid="modalCard"
      onClick={(ev) => {
        ev.stopPropagation()
      }}
    >
      <CloseButton onClick={() => onClose()}>
        <CgClose size={24} />
      </CloseButton>
      {children}
    </ModalBox>
  )
}

const UpdateShareModal = ({
  fundId,
  clientFund,
  title,
  percentage,
  onClose,
  parent2Callback,
}: {
  fundId: string
  clientFund: string
  title: string
  percentage: number
  onClose: () => void
  parent2Callback: () => void
}) => {
  const [step, setStep] = useState<UpdateShare>(UpdateShare.Form)
  const [data, setData] = useState<{
    fundId: string
    clientFund: string
    titleEdit: string
    percentageEdit: number
    error: string
  }>({
    fundId,
    clientFund,
    titleEdit: "",
    percentageEdit: 0,
    error: "",
  })

  return (
    <Overlay onClick={() => setStep(UpdateShare.Form)}>
      <ModalCard onClose={onClose}>
        {step === UpdateShare.Form && (
          <UpdateShareHolding
            fundId={fundId}
            clientFund={clientFund}
            title={title}
            percentage={percentage}
            onSubmit={(titleEdit, percentageEdit) => {
              setData((prev) => ({
                ...prev,
                titleEdit,
                percentageEdit,
              }))
              setStep(UpdateShare.Confirm)
            }}
          />
        )}
        {step === UpdateShare.Confirm && (
          <ConfirmUpdateShare
            fundId={data.fundId}
            clientfund={data.clientFund}
            title={data.titleEdit}
            percentage={data.percentageEdit}
            onCancel={() => onClose()}
            onError={(error) => {
              setData((prev) => ({ ...prev, error }))
              setStep(UpdateShare.Error)
            }}
            onSuccess={() => onClose()}
            parentCallback={() => parent2Callback()}
          />
        )}
        {step === UpdateShare.Error && `API Error: ${data.error}`}
      </ModalCard>
    </Overlay>
  )
}

export default UpdateShareModal
